import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61283cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice" }, [
  /*#__PURE__*/_createTextVNode(" Al continuar, aceptas la "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://getindya.com/aviso-legal/"
  }, " política de privacidad "),
  /*#__PURE__*/_createTextVNode(" y "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://getindya.com/proteccion-de-datos-gdpr/"
  }, " protección de datos "),
  /*#__PURE__*/_createTextVNode(" de INDYA. ")
], -1))
const _hoisted_2 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NameInput = _resolveComponent("NameInput")!
  const _component_EmailInput = _resolveComponent("EmailInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_NameInput, {
        modelValue: _ctx.form.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
        placeholder: "Nombre",
        error: _ctx.errors.name,
        onEnter: _ctx.throwEvent,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors.name = _ctx.validateNameField($event.modelValue)))
      }, null, 8, ["modelValue", "error", "onEnter"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_EmailInput, {
        modelValue: _ctx.form.email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
        error: _ctx.errors.email,
        placeholder: "Email",
        onEnter: _ctx.throwEvent,
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors.email = _ctx.validateEmailField($event.modelValue)))
      }, null, 8, ["modelValue", "error", "onEnter"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_PasswordInput, {
        modelValue: _ctx.form.password,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
        type: "password",
        placeholder: "Contraseña",
        error: _ctx.errors.password,
        message: "Mínimo 8 caracteres",
        onEnter: _ctx.throwEvent,
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors.password = _ctx.validatePasswordField($event.modelValue)))
      }, null, 8, ["modelValue", "error", "onEnter"])
    ]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        onClick: [
          _ctx.throwEvent,
          _cache[6] || (_cache[6] = ($event: any) => (_ctx.window?.dataLayer.push({
        event: 'virtual_pageview_email',
        })))
        ],
        disabled: !_ctx.formValidated,
        variant: "turquoise"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Continuar ")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}